import {CardContent} from "@mui/material";
import {Checkbox} from "@variocube/app-ui";
import React from "react";
import {StepProps} from "./step-props";
import {WizardStepCard} from "./wizard-step-card";

export function InputTaxDeductibleStep(
	{active, completed, invoice, onChange}: Readonly<StepProps>,
) {
	return (
		<WizardStepCard
			active={active}
			completed={completed}
			title="Vorsteuerabzug"
			activeChildren={
				<CardContent>
					<Checkbox
						value={invoice.inputTaxDeductible ?? false}
						onChange={inputTaxDeductible => onChange({inputTaxDeductible})}
						label="Das Fahrzeug ist vorsteuerabzugsberechtigt"
					/>
				</CardContent>
			}
			completedChildren={
				<CardContent>
					{invoice.inputTaxDeductible
						? "Vorsteuerabzugsberechtigt"
						: "Nicht vorsteuerabzugsberechtigt"}
				</CardContent>
			}
		/>
	);
}
